var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.28564C8.57153 6.0765 10.3624 4.28564 12.5715 4.28564H30.8573L39.4287 12.8571V39.7142C39.4287 41.9233 37.6378 43.7142 35.4287 43.7142H12.5715C10.3624 43.7142 8.57153 41.9234 8.57153 39.7142V8.28564Z",
    fill: "url(#paint0_linear_3069_9370)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8573 12.8572L39.4287 12.8572L30.8573 4.28575L30.8573 10.8572C30.8573 11.9617 31.7527 12.8572 32.8573 12.8572Z",
    fill: "#9271D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6407 21.5072C21.4307 21.4022 21.1781 21.4022 20.9681 21.5072C20.7338 21.6243 20.5715 21.8633 20.5715 22.1611V30.9892C20.5715 31.295 20.779 31.4997 20.9281 31.5928C21.0837 31.6901 21.3614 31.7827 21.6407 31.643C21.6543 31.6362 21.6677 31.6287 21.6806 31.6207L28.7907 27.1784C29.2604 26.9195 29.2604 26.2307 28.7907 25.9719L21.6806 21.5296C21.6677 21.5215 21.6543 21.514 21.6407 21.5072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9370",
    x1: 24.0001,
    y1: 43.7142,
    x2: 24.0001,
    y2: 4.28564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9271D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A40BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4Icon);
export default __webpack_public_path__ + "static/media/mp4-icon.3db40acf75efce2f5bf750f40f2a8be2.svg";
export { ForwardRef as ReactComponent };